export class FormField {
    public static BankAccountKey = 'bankAccountKey';
    public static IsDefault = 'isDefault';
    public static Notes = 'notes';
    public static RequestAmount = 'requestAmount';
}
